import CreatorAddMediaComponent from "./CreatorAddMediaComponent";
export default CreatorAddMediaComponent;
